import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TopUpRequestService {
  

  private http = inject(HttpClient);

  walletTopupRequest(businessAccountId: string, amount: number) {
    const create_agency_url = `${environment.shout_api.url}/wallet-topup-requests`;
    return this.http.post(create_agency_url, {
      businessAccountId,
      amount
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
  
  getTopupRequests(status: TopRequestStatusEnum) {
    const get_topup_requests_url = `${environment.shout_api.url}/wallet-topup-requests/filter`;
    return this.http.post(get_topup_requests_url, {
      status
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  approve(id:string){
    const approve_topup_request_url = `${environment.shout_api.url}/wallet-topup-requests/${id}/approve`;
    return this.http.post(approve_topup_request_url, {}, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  decline(id:string){
    const decline_topup_request_url = `${environment.shout_api.url}/wallet-topup-requests/${id}/decline`;
    return this.http.post(decline_topup_request_url, {}, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}

export enum TopRequestStatusEnum {
  All = 0,
  Created = 1,
  InProgress = 2,
  Approved = 3,
  Declined = 4
}